module.exports = __webpack_public_path__ + "static/media/orders.2072900f.svg";